import { render, staticRenderFns } from "./MVP.vue?vue&type=template&id=fc0cdbce&"
import script from "./MVP.vue?vue&type=script&lang=js&"
export * from "./MVP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports